function none() {}

export default function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-selection/src/selector.js
// module id = vXaf
// module chunks = 0